import { render, staticRenderFns } from "./ReplicationTable.vue?vue&type=template&id=11fd28ea&scoped=true"
import script from "./ReplicationTable.vue?vue&type=script&lang=js"
export * from "./ReplicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd28ea",
  null
  
)

export default component.exports